export const JWT_AUTH = 'JWT_AUTH';
